import { render, staticRenderFns } from "./tasks-list.vue?vue&type=template&id=47f390dc&scoped=true"
import script from "./tasks-list.vue?vue&type=script&lang=js"
export * from "./tasks-list.vue?vue&type=script&lang=js"
import style0 from "./tasks-list.vue?vue&type=style&index=0&id=47f390dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f390dc",
  null
  
)

export default component.exports